module.exports = __webpack_public_path__ + "static/media/alipay.0c7629e9.svg";